var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field-dropdown',{staticStyle:{"margin-bottom":"1.5rem"},attrs:{"list":_vm.fontFamilyList,"value":_vm.selectedFont,"show-active-item":true},on:{"input":(newValue) => _vm.$emit('input', newValue)}})
}
var staticRenderFns = []

export { render, staticRenderFns }